import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {ApiCrudService} from "../../shared/services/ApiCrud.service";
import { environment } from '../../../environments/environment';

import * as moment from "moment";

@Component({
  selector: 'Openpay-welcome-page',
  templateUrl: './welcome-page.component.html',
  styleUrls: ['./welcome-page.component.scss']
})

export class WelcomePageComponent implements OnInit {

  public callbackUrl: string = "#"
  private code: any
  private registerData: String;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private apiCrudService: ApiCrudService
  ) { }

  ngOnInit(): void {
    this.handleQueryParams();
    this.validateTimeOfCode()
  }

  private handleQueryParams(){
    this.callbackUrl = this.route.snapshot.queryParamMap.get("callbackUrl") || window.location.href;
    this.code = this.route.snapshot.queryParamMap.get("code")
    this.registerData = this.route.snapshot.queryParamMap.get("registerData")
  }

  private validateTimeOfCode = () => {

    if(!this.code){
      this.router.navigate(['not-found']).then()
      return
    }

    let codeValue = this.base64DecodeUnicode(this.code)

    let [time, place] = codeValue.split('-')

    /*if((moment().utc(true).valueOf() - (30 * 1000)) > +time){
      this.router.navigate(['not-found']).then()
    }*/

    if(place !== 'welcome'){
      this.router.navigate(['not-found']).then()
    }

  }


  goToCallbackUrl() {
    window.location.href = this.callbackUrl.includes("http") ? this.callbackUrl : this.base64DecodeUnicode(this.callbackUrl);
  }

  goToRegister(){
    console.log(this.registerData);
    switch (this.registerData){
      case 'MX': window.location.href = environment.registerUrlMx;
      break;
      case 'CO': window.location.href = environment.registerUrlCo;
      break;
      case 'AR': window.location.href = environment.registerUrlAr;
      break;
    }
  }

  base64DecodeUnicode (str){

    let percentEncodedStr = atob(str).split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join('');


    return decodeURIComponent(percentEncodedStr);
  }
}
